import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudDownloadAlt, faPencilAlt, faTrashAlt, faEdit,faSearch } from "@fortawesome/free-solid-svg-icons";
import axios from 'axios'
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { connect } from 'react-redux';
import { css } from "@emotion/core";
import FadeLoader from "react-spinners/FadeLoader";
import ReactTooltip from "react-tooltip";
const override = css`
  display: block;
  top:50%;
  margin: 0 auto;
  border-color: red;
`;

class PriceListModule extends Component { 
    
    constructor(props) {
        super(props)

        var curr = new Date();
        curr.setDate(curr.getDate());
        var todaydate = curr.toISOString().substr(0,10);
    
        this.state = {
            Distributorbtn: "Popup_tabButtons",
            DistServbtn: "Popup_tabButtons",
            plPriceList: [],
            plOrgPriceList: [],
            httpURL: this.props.httpURL,
            loginuserObj: this.props.userObj,
            currentDate:todaydate,        
        }
    
    }
    
    componentDidMount() {
        this.getPLPriceList();       
    }
    getPLPriceList() {
        this.setState({
            loading: true
        });
        axios.get(this.state.httpURL + "/webmaster/getPriceList")
            .then(response => response.data)
            .then((data) => {
                if (data.valid) {                    
                    this.setState({
                        plPriceList : data.priceList,
                        plOrgPriceList : data.priceList
                    })
                    ReactTooltip.rebuild();
                } else {
                    alert(data.responseMsg);
                }
                this.setState({
                    loading: false
                });
            }).catch(err => {
                //console.log(err)
                this.setState({
                    loading: false
                });
                alert(err);
            })
    }
    
    filterList = (event) => {
        let filtered =this.state.plOrgPriceList;
        let inputFields = document.getElementsByClassName('maingrid');
        for (var i = 0; i < inputFields.length; i++) {
            if (inputFields[i].value !== '') {

                var searchString = inputFields[i].value;
                var fieldName = inputFields[i].name; //list object column name

                filtered = filtered.filter(od => (
                   od[fieldName].toLocaleString().toLowerCase().search(searchString.toLowerCase()) !== -1 
                ));
            }
        }
        this.setState({
            plPriceList: filtered
        })
    }

     render() {
        return (
            <div className="O2Container_Wrapper">
                <ReactTooltip/>
                <div className="O2Container_Table">
                    <div className="O2Table_Header"><span>PRICE LIST</span></div>
                    <div className="Table_wrapper">
                        <table className="customTable" id="priceList_Table">
                            <thead>
                                <tr>
                                <th>Pricelist Code
                                        <div className="searchWrapper">
                                            <FontAwesomeIcon className="SearchIcon" icon={faSearch} style={{padding:'0px 4px'}}/>
                                            <input type="text" className="tableMultiFilterSearch_input maingrid" name="m_pricelist_id" onChange={this.filterList}/>
                                        </div>
                                    </th>
                                    <th>Name
                                        <div className="searchWrapper">
                                            <FontAwesomeIcon className="SearchIcon" icon={faSearch} style={{padding:'0px 4px'}}/>
                                            <input type="text" className="tableMultiFilterSearch_input maingrid" name="name" onChange={this.filterList}/>
                                        </div>
                                    </th>
                                    <th>Description
                                        <div className="searchWrapper">
                                            <FontAwesomeIcon className="SearchIcon" icon={faSearch} style={{padding:'0px 4px'}}/>
                                            <input type="text" className="tableMultiFilterSearch_input maingrid" name="description" onChange={this.filterList}/>
                                        </div>
                                    </th>
                                    <th>Active
                                        <div className="searchWrapper">
                                            <FontAwesomeIcon className="SearchIcon" icon={faSearch} style={{padding:'0px 4px'}}/>
                                            <input type="text" className="tableMultiFilterSearch_input maingrid" name="isactive" onChange={this.filterList}/>
                                        </div>
                                    </th>
                                    <th className="scroller"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>                                             
                                    {/* <td>2589</td>
                                    <td>Y</td>
                                    <td>2589</td>
                                    <td>Y</td> */}
                                    {
                                        !this.state.plPriceList || this.state.plPriceList === null || this.state.plPriceList.length === 0 ?
                                        <tr align="center">
                                            <td colSpan="5">No PriceList Available</td>
                                        </tr> :
                                        this.state.plPriceList.map((pm,i) => (
                                            <tr>                                                                                              
                                                <td data-tip={pm.m_pricelist_id}>{pm.m_pricelist_id}</td>
                                                <td data-tip={pm.name}>{pm.name}</td>
                                                <td data-tip={pm.description}>{pm.description}</td>
                                                <td data-tip={pm.isactive}>{pm.isactive}</td>                                                                                       
                                            </tr>
                                        ))
                                    }
                                </tr> 
                               
                            </tbody>
                        </table>
                    </div>
                    <div className="O2Table_bottomSubContainer">
                        <div className="O2Table_PageCount"><span className="pageCalc_container">Showing<span>{this.state.plPriceList ? this.state.plPriceList.length : 0}</span>entries</span></div>
                        {/* <div className="O2Table_Next"><span className="Nxtprev_btn">Next<FontAwesomeIcon icon={faAngleDoubleRight} style={{ padding: '0px 8px' }} /></span></div>
                        <div className="O2Table_Prev"><span className="Nxtprev_btn"><FontAwesomeIcon icon={faAngleDoubleLeft} style={{ padding: '0px 8px' }} /> Previous</span></div> */}
                    </div>
                    {/* <div className="O2Table_bottomSubContainer">
                        <div className="O2Table_ExpExcel"><FontAwesomeIcon icon={faCloudDownloadAlt} style={{ padding: '0px 8px' }} /></div>
                    </div> */}
                    {/* <div className="O2Table_ExpExcel"><FontAwesomeIcon icon={faCloudDownloadAlt} style={{padding:'0px 8px'}}/><ReactHTMLTableToExcel className="download-table-xls-button" table="priceList_Table" filename={"PriceList_"+this.state.currentDate}
                        sheet="tablexls" buttonText="Excel Export"/></div> */}
                    {/* <div className="O2Table_Footer">
                        <button>Close</button>
                    </div> */}
                </div>
                <FadeLoader
                    css={override}
                    size={150}
                    color={"#123abc"}
                    loading={this.state.loading}
                />   
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        userObj: state.userObj,
        httpURL: state.httpURL        
    }
}
export default connect(mapStateToProps)(PriceListModule)
// export default PriceListModule



